import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "emptyValue",
})
export class EmptyValuePipe implements PipeTransform {
    transform(rawValue: unknown, fallbackValue: string = "N/A"): string {
        if (!rawValue && typeof rawValue !== "number") {
            return fallbackValue;
        }

        if (Array.isArray(rawValue) && !rawValue.length) {
            return fallbackValue;
        }

        return rawValue.toString();
    }
}
